import React, { useCallback } from 'react';
import Select from 'react-select-v3';

import { StyledFilter, reactSelectStyles } from './styled';
import { injectIntl } from 'react-intl';
const AlertsFilter = ({
  selectProps = {},
  alertsValue,
  showAll = true,
  onChange,
  stylingProps,
  intl,
}) => {
  const handleChange = useCallback(
    (change) => {
      onChange(change);
    },
    [onChange]
  );
  const t = intl.messages.modules.Filters.alerts_filter;
  const options = [
    { label: t.not_started, value: 'is_not_started' },
    { label: t.late, value: 'is_late' },
    { label: t.standstill, value: 'is_standstill' },
    // { label: 'Possible delay', value: 'is_delayed' },
  ];

  const optionsWithAll = [{ label: t.all_problematic, value: 'problematic' }, ...options];

  return (
    <StyledFilter {...stylingProps}>
      <Select
        value={alertsValue}
        closeMenuOnSelect={false}
        defaultValue={null}
        isMulti
        options={showAll ? optionsWithAll : options}
        onChange={handleChange}
        styles={reactSelectStyles}
        placeholder={t.placeholder}
        {...selectProps}
      />
    </StyledFilter>
  );
};

AlertsFilter.filterName = 'AlertsFilter';

export default injectIntl(AlertsFilter);
